module.exports = __webpack_public_path__ + "static/media/logo.bb53fb86.png";